import React from 'react';
import { DASHBOARD_DISPLAY_NAME } from '@utils/constants';
import NameLink from '../NameLink';
import Timestamp from '../Timestamp';
import DashboardListOptionsMenu from '../DashboardListOptionsMenu';
import { DataSourceMapping } from '../../utils';

const Pulse5DashboardColumns = [
  {
    title: 'Dashboard',
    dataKey: 'name',
    key: 'name',
    width: 500,
    sortable: true,
    resizable: true,
    cellRenderer: ({ rowData }) => {
      const { id, name, productName, dashboardType } = rowData;
      return (
        <NameLink
          id={id}
          productName={productName}
          name={name}
          dashboard="pulse5"
          dashboardType={dashboardType}
        />
      );
    },
  },
  {
    title: 'Saved By',
    dataKey: 'createdBy',
    key: 'createdBy',
    width: 250,
    sortable: true,
    resizable: true,
  },
  {
    title: 'Saved On',
    dataKey: 'createdAt',
    key: 'createdAt',
    width: 170,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: time }) =>
      time && time !== '-' ? <Timestamp timestamp={time} /> : '-',
  },
  {
    title: 'Saved From',
    dataKey: 'dashboardTypeId',
    key: 'savedFrom',
    width: 200,
    sortable: true,
    resizable: true,
    cellRenderer: ({ rowData }) => {
      const {
        dashboardType: { id },
      } = rowData;
      return <div>{DASHBOARD_DISPLAY_NAME[id]}</div>;
    },
  },
  {
    title: 'Last Updated On',
    dataKey: 'updatedAt',
    key: 'updatedAt',
    width: 170,
    sortable: true,
    resizable: true,
    cellRenderer: ({ cellData: time }) =>
      time && time !== '-' ? <Timestamp timestamp={time} /> : '-',
  },
  {
    title: 'Data Source',
    key: 'productName',
    width: 100,
    sortable: true,
    resizable: true,
    cellRenderer: ({ rowData }) => DataSourceMapping[rowData.productName || 'ei'],
  },
  {
    title: 'Actions',
    dataKey: '',
    key: 'menu-options',
    sortable: false,
    resizable: true,
    align: 'left',
    flexGrow: 1,
    width: 150,
    cellRenderer: ({ rowData }) => {
      return <DashboardListOptionsMenu rowData={rowData} />;
    },
  },
];

export default Pulse5DashboardColumns;
